import { DataSubjectTypeDTO } from '@ketch-com/figurehead'
import { DataCategory } from 'interfaces/dataCategory/dataCategory'
import { CanonicalPurposeDTO } from 'interfaces/purposes/canonicalPurpose'
import { PurposeDTO, PurposeFormDTO } from 'interfaces/purposes/purpose'

type Args = {
  values: PurposeFormDTO
  canonicalPurposes: CanonicalPurposeDTO[]
  dataSubjectTypes: DataSubjectTypeDTO[]
}

export const mapCreatePurposeFormValuesToPayload = ({
  values,
  canonicalPurposes,
  dataSubjectTypes,
}: Args): PurposeFormDTO => {
  const canonicalPurposesList = (values.canonicalPurposeCodes || [])
    ?.map(code => {
      return canonicalPurposes?.find(purpose => purpose.code === code)
    })
    .filter(Boolean)

  const dataSubjectTypesPayload = (values?.dataSubjectTypeCodes || [])
    .map(code => dataSubjectTypes.find(({ code: c }) => c === code))
    .filter(Boolean)

  return {
    canonicalPurposes: canonicalPurposesList as CanonicalPurposeDTO[],
    code: values.code,
    cookies: values.cookies,
    dataRole: values.dataRole,
    dataSubjectRole: values.dataSubjectRole,
    dataSubjectTypes: dataSubjectTypesPayload as DataSubjectTypeDTO[],
    dataUsageDuration: Number(values.dataUsageDuration) || undefined,
    dataUsageDurationUnit: values.dataUsageDurationUnit,
    description: values.description,
    displayDescription: values.displayDescription,
    displayName: values.displayName,
    enabled: values.enabled,
    legalBases: values.legalBases,
    name: values.name,
    processingPurpose: values.processingPurpose,
    requiresDisplay: values.requiresDisplay,
    translations: values.translations,
  }
}

export const mapUpdatePurposeDataCategoriesToPayload = (values: DataCategory[], purpose: PurposeDTO) => {
  return {
    ...purpose,
    dataCategories: values,
  }
}
